import React from 'react';
import '@/styles/animated-floating-button.css';

export interface AnimatedFloatingButtonProps {
  icon: React.ReactNode;
  label: string;
  gradientFrom: string;
  gradientTo: string;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

export const AnimatedFloatingButton: React.FC<AnimatedFloatingButtonProps> = ({
  icon,
  label,
  gradientFrom,
  gradientTo,
  onClick,
  children,
  className = '',
  ariaLabel,
}) => {
  return (
    <div className="animated-floating-btn-wrapper">
      <button
        className={`animated-floating-btn ${className}`}
        style={{
          '--gradient-from': gradientFrom,
          '--gradient-to': gradientTo,
        } as React.CSSProperties}
        onClick={onClick}
        aria-label={ariaLabel || label}
      >
        {/* Gradiente de fundo (opacity 0 → 1 no hover) */}
        <span className="gradient-bg" />
        
        {/* Glow blur embaixo */}
        <span className="glow-blur" />
        
        {/* Ícone (scale 1 → 0 no hover) */}
        <span className="icon-wrapper">
          {icon}
        </span>
        
        {/* Texto (scale 0 → 1 com delay no hover) */}
        <span className="label-text">
          {label}
        </span>
      </button>
      
      {/* Children renderizados fora do botão (ex: Popover) */}
      {children}
    </div>
  );
};
